import { del, get, post, put } from "../../data/api";

export async function getMerchandise() {
    return await get("tool/merchandise");
}

export async function getMerchandiseMovements(id) {
    return await get(`tool/merchandise/${id}/movements`);
}

export async function getUpcomingMerchandisePurchaseReminders() {
    return await get("tool/merchandise/upcoming-purchase-reminders");
}

export async function createMerchandise(dto) {
    return await post(dto, "tool/merchandise");
}

export async function updateMerchandise(id, dto) {
    return await put(dto, `tool/merchandise/${id}`);
}

export async function deleteMerchandise(id) {
    return await del(`tool/merchandise/${id}`);
}

export async function createMerchandiseMovement(id, dto) {
    return await post(dto, `tool/merchandise/${id}/movements`);
}

export async function updateMerchandiseMovement(id, movementId, dto) {
    return await put(dto, `tool/merchandise/${id}/movements/${movementId}`);
}

export async function deleteMerchandiseMovement(id, movementId) {
    return await del(`tool/merchandise/${id}/movements/${movementId}`);
}
